'use client';

import { useTranslations } from 'next-intl';
import { useCreditsStore } from '@/lib/stores/credits-store';
import { cn } from '@/lib/cn';

/** Explain the one-time benefit only after a wallet has loaded. */
export function CreditsPolicyNote({ className }: { className?: string }) {
  const t = useTranslations('creditsJourney');
  const credits = useCreditsStore((state) => state.credits);
  if (!credits) return null;
  return (
    <p className={cn('text-[11px] leading-[1.65] text-[#64748B]', className)}>
      {t(credits.welcome_credit_status === 'legacy_satisfied' ? 'legacyBalanceRetained' : 'oneTimeNote')}
    </p>
  );
}
